import { gql } from "apollo-boost";

const GET_REPORT_DATA = gql`
  query getReportData($input: GetReportDataInput) {
    getReportData(input: $input) {
      data {
        _id
        orderNumber
        lineItemId
        title
        vendor
        quantity
        markup
        sellerCommission
        createdAt
        orderAcceptanceDate
        orderReadyToCollectDate
        orderPickupTime
        orderDeliveryDate
        fulfillmentStatus
        shipping
        tax
        sku
        orderStatus
        vendorPaymentStatus
        vendorAmount
        vendorPaidDate
        price
        productCost
        discount
        returns
        productType
        customerProductPrice
        totalSalesPrice
        vendorDiscount
        grossSales
        grossProfit
        trackingNumber
        paymentGateway
        vendorId
        amountPaid
        amountRefunded
        totalOrderValue
        dueDate
        commissionTax
        consignmentShipping
        priceAfterVendorDiscount
        paymentId
        voucherDetails {
          totalDiscount
          operatorDiscount
          xhawiVendorDiscount
          makasibRedeemedDiscount
          makasibPhoneNumber
          makasibPointsEarned
        }
        omantel {
          itemAmountToCollect
          dppTaxablePrice
          paymentPlan
        }
        commissionSetting {
          rate
          type
        }
        commissionTaxSetting {
          rate
          type
        }
      }
      hasMore
      totalCount
      error
      status
    }
  }
`;

export default GET_REPORT_DATA;
